<template>
  <div>
    <div class="backFF">
      <div class="folding flex">
        <div class="search-header flex" v-if="searchStatus == false?false:true">
          <el-input v-model="searchValue" :placeholder="placeholder" class="search-input input-with-select" size="small"
            :maxlength="36" @keyup.enter.native="searchAction">
            <el-select v-model="typeValue" filterable placeholder="请选择" size="small" class="searchselect" slot="prepend"
              v-if="selectOptions.length>0">
              <el-option v-for="(item,index) in selectOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            
             <el-button slot="append"  @click="searchAction" type="primary">查询</el-button>
          </el-input>
        </div>
        <div class="bit_list flex flex1">
          <div class="flex1">
            <el-badge :is-dot="searchFormValue && flag == false" class="item">
              <el-button size="small" @click="advancedSearch" v-if="searchFormData">
                高级搜索
              </el-button>
            </el-badge>
          </div>
          <div class="bit_list_item">
            <div v-for="(item,index) in btnList" class="float_btn" :key="index">
              <el-button @click="btnAction(item.type)" size="small" v-if="item.type == 'add'" icon="el-icon-plus" type="primary">
                {{item.name}}</el-button>
              <el-button @click="btnAction(item.type)" size="small" v-else>{{item.name}}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="searchDialog" v-if="flag">
        <el-dialog ref="dialogDom" title="高级搜索" :visible.sync="flag" width="40%" class="jmtool-dialog" @closed="close"
          :close-on-click-modal="false" :before-close="close">
          <myform ref="myform" :formData="searchFormDataBak" reform="reform" v-if="flag"></myform>
          <span slot="footer" class="dialog-footer">
            <el-button @click="reset">重 置</el-button>
            <el-button type="primary" @click="confirm">搜 索</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
  import GlobalUtil from '@/utils/globalUtil';
  export default {
    props: {
      placeholder: {
        type: String,
        default: function () {
          return '请输入'
        }
      },
      searchStatus: {
        type: Boolean,
        default: function () {
          return true
        },
      },
      viewList: {
        type: Array,
        default: function () {
          return []
        }
      },
      btnList: {
        type: Array,
        default: function () {
          return [{
            type: 'add',
            name: '新增'
          }, {
            type: 'reload',
            name: '刷新'
          }, {
            type: 'export',
            name: '导出'
          }]
        }
      },
      selectOptions: {
        type: Array,
        default: function () {
          return []
        }
      },
      // tab菜单切换
      hdtab: {
        type: Array,
        default: function () {
          return []
        }
      },
      // 文字宽度
      labelWidth: {
        type: String,
        default: '110px'
      },
      // 过滤字段
      searchFormData: {
        type: Array,
        default: function () {
          []
        }
      },
    },
    data() {
      return {
        flag: false,
        activeName: null,
        typeValue: '',
        searchValue: '',
        showForm: false,
        outData: {},
        viewValue: '',
        searchFormDataBak: [],
        searchFormDataBase: [],
        searchFormValue: null
      }
    },
    created() {
      let obj = GlobalUtil.deepClone(this.searchFormData);
      this.searchFormDataBak = obj;
      this.searchFormDataBase = obj;
      if (this.hdtab.length) {
        this.activeName = this.hdtab[0].label
      }
      if (this.selectOptions && this.selectOptions.length > 0) {
        this.typeValue = this.selectOptions[0].value
      }
      if (this.viewList && this.viewList.length > 0) {
        this.viewValue = this.viewList[0].value
      }
    },
    mounted() {

      // console.log(obj) 
    },
    methods: {
      returnObj() {
        if (this.selectOptions) {
          if (this.searchValue) {
            return {
              type: this.typeValue,
              value: this.searchValue
            }
          } else {
            return {
              type: this.typeValue,
              value: this.searchValue
            }
          }
        } else {
          return this.searchValue
        }
      },
      viewValueChange(data) {
        this.$emit('viewValueChange', data)
      },
      handleClick(tab, event) {
        // console.log(tab.$attrs);
        this.$emit('htabAction', tab.$attrs.value)
      },
      advancedSearch() {
        // console.log(this.searchFormData)
        this.flag = true;
      },
      reset() {
        // this.$refs.myform.resetForm();
        this.searchFormDataBak = GlobalUtil.deepClone(this.searchFormDataBase);
        this.searchFormValue = null;
        this.$emit('advancedReset', null);
        this.$refs.myform.resetForm();
        console.log(233333)
      },
      close() {
        // this.$emit('advancedReset', null);
        this.flag = false;
      },
      confirm() {
        let obj = GlobalUtil.deepClone(this.$refs.myform.submitForm());
        for (var k in obj) {
          if (!obj[k]) {
            if (obj[k] === 0) {} else {
              delete obj[k]
            }
          } else if (obj[k].constructor == Array && obj[k].length === 0) {
            delete obj[k]
          } else if (obj[k].constructor == String && obj[k] === '') {
            delete obj[k]
          }
        }

        if (JSON.stringify(obj) === '{}') {
          this.searchFormDataBak = GlobalUtil.deepClone(this.searchFormData);
          this.searchFormValue = null;
          this.$emit('advancedAction', {});
        } else {
          let bakObj = GlobalUtil.deepClone(this.searchFormData);
          this.searchFormDataBak = GlobalUtil.fillEditData(obj, bakObj)
          this.searchFormValue = obj;
          this.$emit('advancedAction', GlobalUtil.deepClone(obj));
        }

        this.flag = false;
      },
      btnAction(str) {
        this.$emit('btnAction', str)
      },
      searchAction() {
        if (this.selectOptions) {
          if (this.searchValue) {
           
            this.$emit('searchAction', {
              type: this.typeValue,
              value: this.searchValue
            });
          } else {
            this.$emit('searchAction', {
              type: this.typeValue,
              value: this.searchValue
            });
          }
        } else {
          this.$emit('searchAction', this.searchValue);
        }
      },
      submitForm() {
        let obj = this.outData;
        obj.acthd = this.acthd;
        this.$emit('filterRes', obj)
      },
      resetForm() {
        for (let item in this.outData) {
          this.outData[item] = ''
        }
      }
    },
    wacth: {
      searchFormData: {
        handler(newData, oldData) {
          console.log(newData)
        },
        deep: true
      }
    }
  }

</script>
<style>
  .el-input-group__prepend {
    background: #ffffff !important;
  }
.el-input-group__append .el-button--primary{
  background: #59CCE1 !important;
  color: #ffffff !important;
}
</style>
<style scoped lang="scss">
  .float_btn {
    float: left;
    margin-left: 8px;
  }

  .backFF {
    background: #ffffff;
    /* border:1px solid rgba(229,229,229,1); */
    /* border- */
  }

  .bit_list_item {
    padding-right: 20px;
  }

  .view_box {
    float: left;
    line-height: 32px;
    margin-right: 20px;
  }

  .view_box .view_name {
    float: left;
    margin-right: 10px;
    font-size: 14px;
  }

  .view_select {
    float: left;
  }

  .my_el_form {
    display: flex;
    flex-wrap: wrap;
    padding-right: 25px;
  }

  .form_item {
    display: flex;
  }

  .all_hd {
    display: flex;
  }

  .folding {
    display: flex;
    /* margin-bottom: 20px; */
    padding-top: 18px;
  }

  .bit_list {
    display: flex;
  }

  .text_btn {
    color: #108EEA;
    cursor: pointer;
  }

  .search_btn {
    background: #108EEA;
    color: #ffffff;
    margin-left: 20px;
  }

  .reset_btn {
    border: 1px solid #e6e6ee;
    color: #888;
    margin-left: 20px;
  }

  .hd_item {
    border: 1px solid #e6e6ee;
    color: #888;
  }

  .act_item {
    color: #108EEA;
    border-color: #108EEA
  }

</style>

<style scoped lang="scss">
  .searchselect {
    width: 100%;
    min-width: 120px;
    line-height: 34px;
  }

  .search-header {
    overflow: hidden;
    background: #fff;
    padding-left: 20px;
    padding-right: 8px;
    position: relative;

    .search_header_btn {
      width: 30px;
      text-align: center;
      position: absolute;
      top: 0px;
      right: 10px;
      line-height: 32px;
    }

    .header-title {
      /* margin-right:20px; */
      font-size: 14px;
      line-height: 30px;
      float: left;
    }

    .header-left {
      float: left;
      margin-right: 15px;
      width: 100px;
      /* display: flex; */
    }

    .header-right {
      /* width: 500px; */
      /* display: flex; */
      margin-left: 20px;
      float: left;
    }

    .search-input {
      float: left;
      width: 380px;
    }

    .search-btn {
      margin: 0 15px;
      float: right;
      width: 120px;
      background: #6890FE;
    }
  }

</style>
